<template>
    <button @click="toggle" :class="{'is-active':active}" class="hamburger hamburger--collapse-r focus:outline-none" type="button">
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
    </button>
</template>

<script>
    export default {
        name: "hamburger",
        data() {
            return {
                active: false
            }
        },
        methods: {
            toggle() {
                this.active = !this.active
                this.$emit('toggleNav', this.active)
            }
        }

    }
</script>